import "./style.scss";

import { cssJoin, toEnkaUrl } from "../../utils/helpers";

import { ABYSS_COLORS } from "../AbyssRankText";
import { ReplaceRowDataOnHover } from "../ReplaceRowDataOnHover";
import { TranslationContext } from "../../context/TranslationProvider/TranslationProviderContext";
import { useContext } from "react";

// import Separator from "../../assets/icons/abyss_separator.png";

// export const STYGIAN_COLORS = {
//   0: "rgb(128, 128, 128)",
//   1: "rgb(128, 128, 128)",
//   2: "rgb(128, 128, 128)",
//   3: "rgb(128, 128, 128)",
//   4: "rgb(255, 217, 0)",
//   5: "rgb(255, 0, 119)",
//   6: "cyan",
// };

export const stygianProgressToColor = (index: number, badge?: boolean) => {
  if (index === 6) {
    if (badge) return ABYSS_COLORS[0];
    return "cyan"; // Dire
  }
  if (index === 5) {
    if (badge) return ABYSS_COLORS[1];
    return "rgb(255, 0, 119)"; // Fearless
  }
  if (index === 4) {
    if (badge) return ABYSS_COLORS[2];
    return "rgb(255, 217, 0)"; // Menancing
  }

  if (badge) return ABYSS_COLORS[4]; // gray badge
  return "gray";
};

export const STYGIAN_DIFF_TO_NAME: any = {
  0: "-",
  1: "Normal",
  2: "Advancing",
  3: "Hard",
  4: "Menacing",
  5: "Fearless",
  6: "Dire",
  7: "Dire",
};

export const NUM_TO_ROMAN: any = {
  0: "", // romans didnt invent a 0 yet :)
  1: "I",
  2: "II",
  3: "III",
  4: "IV",
  5: "V",
  6: "VI",
  7: "VI",
};

export const STYGIAN_DIFF_TO_ICON = [1, 2, 3, 4, 5, 6, 7].reduce(
  (acc, diff) => {
    acc[diff] = toEnkaUrl(`UI_LeyLineChallenge_Medal_${diff}`);
    return acc;
  },
  {} as any
);

type StygianRankTextProps = {
  row?: any;
  badge?: boolean;
  useReplaceRowDataOnHover?: boolean;
};

export const StygianRankText: React.FC<StygianRankTextProps> = ({
  row,
  badge,
  useReplaceRowDataOnHover = false,
}) => {
  const { translate } = useContext(TranslationContext);

  const stygianIndex = row?.playerInfo?.stygianIndex || row?.stygianIndex;
  const stygianSeconds = row?.playerInfo?.stygianSeconds || row?.stygianSeconds;
  const stygianScore = row?.playerInfo?.stygianScore || row?.stygianScore;

  const seconds = stygianSeconds || "0";
  const diff = stygianIndex || "-";

  const diffText = STYGIAN_DIFF_TO_NAME[diff] || "-";
  const diffRoman = NUM_TO_ROMAN[diff] || "-";
  const color = stygianProgressToColor(diff, badge);
  const icon = STYGIAN_DIFF_TO_ICON[diff === 6 && seconds <= 180 ? 7 : diff];
  // const susLevel = row?.isCheating ? 2 : row?.susLevel || 0;
  const susLevel = row?.susLevel || 0;
  const isSuspicious = susLevel > 0;
  const title = `${isSuspicious ? "SUSPICIOUS CLEAR - " : ""}${translate(
    "Stygian Onslaught"
  )} ${diffRoman} - ${diffText}: ${seconds}s${
    useReplaceRowDataOnHover ? ` (${stygianScore?.toFixed(0)} score)` : ""
  }`;

  const classNames = cssJoin([
    "abyss-cell",
    badge ? "abyss-badge" : "",
    isSuspicious ? "strike-through" : "",
  ]);

  return (
    <div
      style={
        {
          "--color": color,
          width: isSuspicious ? "fit-content" : "auto",
        } as React.CSSProperties
      }
      className={classNames}
      title={title}
      translate="no"
    >
      {!stygianSeconds && !stygianIndex ? (
        "-"
      ) : (
        <>
          {useReplaceRowDataOnHover ? (
            <ReplaceRowDataOnHover
              data={`${stygianScore?.toFixed(0)}`}
              onHoverData={
                <>
                  <img
                    className="abyss-star"
                    width={16}
                    height={16}
                    alt={diffRoman}
                    src={icon}
                    style={{ fontSize: 12 }}
                  />{" "}
                  {seconds}s
                </>
              }
            />
          ) : (
            <>
              <img
                className="abyss-star"
                width={16}
                height={16}
                alt={diffRoman}
                src={icon}
              />{" "}
              {seconds}s
            </>
          )}
        </>
      )}
    </div>
  );
};
